import {
	cargoStaffPageApi,
	createStaffApi,
	productPageApi,
	earningsPageApi,
	cargoAllStaffApi
} from '@/apis/cargo.js'
export default {
	async cargoStaffPage(context, params) {
		return cargoStaffPageApi(params)
	},
	async createStaff(context, body) {
		return createStaffApi(body)
	},
	async productPage(context, {params, companyCode}) {
		return productPageApi(companyCode, params)
	},
	async earningsPage(context, params) {
		return earningsPageApi(params)
	},
	async cargoAllStaff(context) {
		return cargoAllStaffApi()
	}
}